import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center items-center text-white" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, [
    /*#__PURE__*/_createTextVNode("Powered by "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://hiring.axelerate.io/",
      class: "font-semibold hover:underline"
    }, "axelerate")
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentRoute === 'Company Board' || _ctx.isWhitelabelJse)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex flex-col px-5 py-6 mt-24", _ctx.branding.backgroundColor])
      }, _hoisted_2, 2))
    : _createCommentVNode("", true)
}